'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var PropTypes = require('prop-types');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var StyledFieldset = /*#__PURE__*/react.styled('fieldset')({
  name: "StyledFieldset",
  "class": "s1bi5cwu",
  propsAsIs: false
});
var _exp = function _exp() {
  return function (_ref) {
    var checked = _ref.checked,
      hasError = _ref.hasError,
      disabled = _ref.disabled;
    return hasError ? 'var(--color-status-critical-lightest)' : checked ? 'var(--color-secondary-input-lightest)' : disabled ? 'var(--color-secondary-inactive-lightest)' : '--color-secondary-white';
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var checked = _ref2.checked,
      hasError = _ref2.hasError,
      disabled = _ref2.disabled;
    return hasError ? '1px solid var(--color-status-critical-lighter)' : checked ? '2px solid var(--color-secondary-input-base)' : disabled ? '1px solid var(--color-secondary-inactive-lighter' : '1px solid var(--color-secondary-input-lighter)';
  };
};
var _exp3 = function _exp3() {
  return function (_ref3) {
    var disabled = _ref3.disabled;
    return disabled ? 'var(--color-secondary-inactive-base)' : 'var(--color-primary-body-base)';
  };
};
var _exp4 = function _exp4() {
  return function (_ref4) {
    var disabled = _ref4.disabled;
    return disabled ? 'none' : 'auto';
  };
};
var _exp5 = function _exp5() {
  return function (_ref5) {
    var hasError = _ref5.hasError;
    return hasError ? 'var(--color-status-critical-lighter)' : 'var(--color-secondary-input-lightest)';
  };
};
var _exp6 = function _exp6() {
  return function (_ref6) {
    var hasError = _ref6.hasError;
    return hasError ? 'var(--color-status-critical-base)' : 'var(--color-secondary-input-base)';
  };
};
var StyledLabel = /*#__PURE__*/react.styled('label')({
  name: "StyledLabel",
  "class": "sdxyqi7",
  propsAsIs: false,
  vars: {
    "sdxyqi7-0": [_exp()],
    "sdxyqi7-1": [_exp2()],
    "sdxyqi7-2": [_exp3()],
    "sdxyqi7-3": [_exp4()],
    "sdxyqi7-4": [_exp5()],
    "sdxyqi7-5": [_exp6()]
  }
});

var useRadio = function useRadio() {
  var _useState = React.useState(''),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var updateCheckedValue = function updateCheckedValue(e) {
    setIsChecked(e.target.value);
  };
  return {
    isChecked: isChecked,
    updateCheckedValue: updateCheckedValue
  };
};
({
  /** Array of Radio objects for the user to select between */
  radios: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    name: PropTypes__default["default"].string.isRequired,
    label: PropTypes__default["default"].string.isRequired,
    value: PropTypes__default["default"].string.isRequired,
    active: PropTypes__default["default"].bool.isRequired
  }).isRequired).isRequired,
  /** Function to call when a radio option is selected */
  onChange: PropTypes__default["default"].func.isRequired,
  /** Function to call when the set of options has changed */
  updateCheckedValue: PropTypes__default["default"].func,
  /** Whether or not the radio component has an option checked */
  isChecked: PropTypes__default["default"].string,
  /** Enables the error display. */
  hasError: PropTypes__default["default"].bool,
  /** Additional classes to be applied to the radio buttons */
  className: PropTypes__default["default"].string,
  /** Disables the ability to change the selected radio button */
  disabled: PropTypes__default["default"].bool
});
var RadioButtons = function RadioButtons(_ref) {
  var radios = _ref.radios,
    onChange = _ref.onChange,
    updateCheckedValue = _ref.updateCheckedValue,
    isChecked = _ref.isChecked,
    className = _ref.className,
    hasError = _ref.hasError,
    disabled = _ref.disabled;
  var inputRefs = [];
  var onKeyDown = function onKeyDown(e) {
    if (e.code === 'Enter') {
      var _inputRefs$index$curr;
      var index = parseInt(e.target.id);
      (_inputRefs$index$curr = inputRefs[index].current) === null || _inputRefs$index$curr === void 0 ? void 0 : _inputRefs$index$curr.click();
    }
  };
  return /*#__PURE__*/jsxRuntime.jsx(StyledFieldset, {
    onChange: updateCheckedValue !== null && updateCheckedValue !== void 0 ? updateCheckedValue : undefined,
    children: radios.map(function (radio, idx) {
      var name = radio.name,
        label = radio.label,
        value = radio.value,
        active = radio.active;
      var isActiveInHook = isChecked === value; // active radio value set in hook
      var id = "".concat(name, "-").concat(label);
      var inputRef = /*#__PURE__*/React__default["default"].createRef();
      inputRefs.push(inputRef);
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: className !== null && className !== void 0 ? className : undefined,
        children: [/*#__PURE__*/jsxRuntime.jsx("input", {
          type: "radio",
          name: name,
          id: id,
          value: value,
          onChange: onChange,
          tabIndex: -1,
          "aria-label": label,
          ref: inputRef,
          disabled: disabled || false
        }), /*#__PURE__*/jsxRuntime.jsx(StyledLabel, {
          checked: active || isActiveInHook // `active` set in radios object || `isActiveInHook` set in hook
          ,
          hasError: (hasError || false) && !isChecked,
          disabled: disabled || false,
          htmlFor: id,
          id: "".concat(idx),
          tabIndex: 0,
          onKeyDown: onKeyDown,
          children: /*#__PURE__*/jsxRuntime.jsx("span", {
            children: label
          })
        })]
      }, label);
    })
  });
};

exports["default"] = RadioButtons;
exports.useRadio = useRadio;
